import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import {YesNoModal} from "../../elements/YesNoModal";
import {FaIcon} from "../../FaIcon";
import {ChannelLogo} from "../../channels/ChannelLogo";
import {ManagedByClientTag} from "../../client/ad_accounts/ManagedByClientTag";
import {AddClientAdAccountButtonWithModal} from "../../client/ad_accounts/AddClientAdAccountButtonWithModal";
import {ReconnectAdAccountModal} from "./ReconnectAdAccountModal";
import {TIENDA_NUBE_CHANNEL} from "../../channels/channels";

class AdAccountDataRowClass extends Component {
    constructor(props) {
        super(props);
        this.handleAdAccountRemove = this.handleAdAccountRemove.bind(this);
        this.handleAdAccountReconnect = this.handleAdAccountReconnect.bind(this);
    }

    handleAdAccountRemove() {
        this.props.onRemove(this.props.adAccountData.ad_account_id)
    }

    handleAdAccountReconnect() {
        this.reconnectModal.toggle();
    }

    renderClientsCell() {
        const {t} = this.props;
        const clientNames = this.props.adAccountData.agency_client_names || [];

        // Tienda ya vinculada: mostramos los nombres de los clientes.
        if (clientNames.length > 0) {
            return clientNames.join(', ');
        }

        // Tienda conectada pero SIN vincular a ningún cliente: no va a traer datos.
        // En vez de dejar la celda vacía (el callejón sin salida silencioso), la
        // convertimos en una señal clara + la acción para vincularla a un cliente.
        return (
            <div className="unlinked-store-cell">
                {/* El propio pill es el disparador del tooltip (hover -> por qué no trae datos),
                    así evitamos un ícono de ayuda suelto. */}
                <span className="info-icon-container unlinked-store-badge">
                    <FaIcon iconName="exclamation-triangle"/>
                    {t('credential_row.unlinked_badge')}
                    <div className="warning-tooltip -rich">
                        <div className="warning-tooltip-body">
                            <p className="warning-tooltip-text"
                               dangerouslySetInnerHTML={{__html: t('credential_row.unlinked_tooltip')}}/>
                        </div>
                    </div>
                </span>
                {/* Acción liviana (link de marca, no botón sólido) para no competir con la CTA
                    primaria "Nueva conexión". Hard reload al vincular: consistente con
                    reconnect/remove de esta pantalla; deuda conocida: podría refrescar solo el
                    listado vía callback del padre (onAdAccountConnectionCreated). */}
                <AddClientAdAccountButtonWithModal
                    channel={this.props.adAccountData.channel}
                    adAccountId={this.props.adAccountData.account_id}
                    afterSuccessfulSubmit={() => window.location.reload()}
                    buttonText={t('credential_row.link_to_client')}
                    buttonTitle={t('credential_row.link_to_client')}
                />
            </div>
        );
    }

    renderAccessStatus() {
        const icon = this.adAccountIsOk() ? "check" : "exclamation-triangle";
        const extraClassOnError = this.adAccountIsOk() ? "" : "no-impressions-alert";
        const noAccessTextDetail = this.props.adAccountData.has_access ? "" : <span style={{fontWeight: "600"}}>Sin acceso desde: {this.props.adAccountData.no_access_since}<br/></span>;

        return (
            <div className={"bu-cell-icon " + extraClassOnError}>
                <FaIcon iconName={icon}/>
                <div className="bu-tooltip">
                    <FaIcon iconName={icon}/>
                    <p className="tooltip-description">
                        {noAccessTextDetail}
                        Último chequeo: {this.props.adAccountData.last_access_check}
                    </p>
                </div>
            </div>
        );
    }

    adAccountIsOk() {
        return this.props.adAccountData.has_access
    }

    renderAuthorizesCell() {
        if (this.props.adAccountData.channel === TIENDA_NUBE_CHANNEL) {
            return null;
        }
        return <td>{this.props.adAccountData.email}</td>;
    }

    render() {
        return (
            <tr key={this.props.adAccountData.ad_account_id}>
                <td style={{paddingLeft: '0.4em'}}>{this.renderAccountColumnText()}</td>
                <td>{this.props.adAccountData.url}</td>
                {this.renderAuthorizesCell()}
                <td>{this.renderClientsCell()}</td>
                <td>{this.renderAccessStatus()}</td>
                <td>
                    <div style={{display: "flex", alignItems: "center", gap: "0.6em"}}>
                        <span style={{cursor: "pointer"}} onClick={this.handleAdAccountReconnect} title="Reconectar cuenta"><FaIcon iconName="sync-alt"/></span>
                        <span>
                            <YesNoModal onYesAnswer={this.handleAdAccountRemove}
                                        title={this.props.t('ecommerce_connection_row.remove_title')}
                                        message={this.props.t('ecommerce_connection_row.remove_message')}
                                        question={this.props.t('ecommerce_connection_row.remove_question')}
                                        buttonClassName={""}
                                        buttonText={""}
                                        buttonTitle="Eliminar conexión y desvincular tienda del cliente"
                                        buttonIconName={"minus-square"}
                                        isSaving={this.props.isSaving}
                            />
                        </span>
                    </div>
                    <ReconnectAdAccountModal ref={instance => { this.reconnectModal = instance; }} adAccountData={this.props.adAccountData} onReconnected={() => window.location.reload()} />
                </td>
            </tr>
        );
    }

    renderAccountColumnText() {
        return (
            <div style={{minWidth: "200px", paddingTop: "10px", paddingBottom: "10px"}}>
                <span style={{float: "left", paddingLeft: '0'}}>
                    <ChannelLogo useOld={false} width="20px" height={"20px"} channel={this.props.adAccountData.channel}
                                 marginLeft={"5px"}/>
                </span>
                <span style={{float: "left", paddingLeft: '0'}}>
                    {this.props.adAccountData.account_id}<br/>{this.props.adAccountData.name}
                    {this.props.adAccountData.managed_by_client &&
                        <><br/><ManagedByClientTag clientName={this.props.adAccountData.managed_by_client_name}/></>}
                </span>
            </div>
        )
    }
}

export const AdAccountDataRow = withTranslation()(AdAccountDataRowClass);
